import { render } from "./debts.vue?vue&type=template&id=bb011000&scoped=true"
const script = {}

import "./debts.vue?vue&type=style&index=0&id=bb011000&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb011000"]])

export default __exports__